import React, { useState } from "react";
import logo from "../assets/jaazCashLogo.png";
import { Input, Modal, Spin } from "antd";
import { v4 as uuidv4 } from "uuid";
import { useSearchParams } from "react-router-dom";

const PaymentCard = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openSucessModal, setOpenSuccessModal] = useState(false);
  const [payerInfo, setPayerInfo] = useState({
    mobileNo: "",
    cnicLast6: "",
    refNo: "",
  });
  const [loader, setLoader] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [searchParams] = useSearchParams();
  const amount = searchParams.get("amount");

  const onYesClick = () => {
    setOpenModal(false);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      setTransactionId(uuidv4());
      setOpenSuccessModal(true);

      setTimeout(() => {
        setOpenSuccessModal(false);
      }, 2000);
    }, 3000);
  };

  const onPayClick = () => {
    if (
      payerInfo.cnicLast6.length !== 6 ||
      payerInfo.mobileNo.length < 11 ||
      payerInfo.refNo.length <= 0
    ) {
      return alert("Please Fill All Fields");
    }

    setOpenModal(true);
    console.log(payerInfo);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center overflow-hidden"
      style={{ height: "100vh" }}
    >
      <Spin size="large" spinning={loader} fullscreen />

      <Modal
        open={openModal}
        cancelButtonProps={{ className: "visually-hidden" }}
        okButtonProps={{ className: "visually-hidden" }}
        closable={false}
        centered
      >
        <div className="d-flex flex-column gap-3 align-items-center justify-content-center">
          <h3>Are You Sure?</h3>
          <div className="d-flex align-items-center justify-content-center gap-3">
            <button
              className="btn  w-100 p-2 px-5 "
              type="button"
              style={{ background: "#FBAD1A" }}
              onClick={() => onYesClick()}
            >
              Yes
            </button>
            <button
              className="btn  w-100 p-2 px-5 btn-danger"
              type="button"
              onClick={() => setOpenModal(false)}
            >
              No
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={openSucessModal}
        cancelButtonProps={{ className: "visually-hidden" }}
        okButtonProps={{ className: "visually-hidden" }}
        closable={false}
        centered
      >
        <div className="d-flex flex-column gap-3 ">
          <h1 className="text-success align-self-center">Payment Success</h1>
          <div className="d-flex align-items-center justify-content-between border border-2 rounded-4 p-3">
            <span>Transaction Id</span>
            <span>{transactionId}</span>
          </div>
          <div className="d-flex align-items-center justify-content-between border border-2 rounded-4 p-3">
            <span>Transaction Amount</span>
            <span>{amount}</span>
          </div>
        </div>
      </Modal>

      <div className="card rounded-3 shadow-lg" style={{ width: "38rem" }}>
        <div className="d-flex align-items-center justify-content-center">
          <img src={logo} width={150} />
        </div>
        <div className="card-body  p-0">
          <div className="d-flex gap-5 flex-column px-4 py-3">
            <div className="d-flex align-items-center justify-content-between border border-2 p-3 rounded-4">
              <span>Invoice Amount</span>
              <span>PKR-{amount}</span>
            </div>

            <div className="row gy-4">
              <div className="col-md-6">
                <div className="d-flex flex-column gap-1">
                  <label id="mobileno" className="fs14">
                    Mobile No
                  </label>
                  <Input
                    type="number"
                    className="w-100 p-2 rounded-3"
                    name="mobileno"
                    placeholder="Enter mobile no"
                    value={payerInfo.mobileNo}
                    onChange={(e) =>
                      setPayerInfo({ ...payerInfo, mobileNo: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex flex-column gap-1">
                  <label id="cnicnum" className="fs14">
                    Cnic Last 6 Digit
                  </label>
                  <Input
                    maxLength={6}
                    type="number"
                    className="w-100 p-2 rounded-3"
                    name="cnicnum"
                    placeholder="Enter Cnic Last 6 Digit"
                    value={payerInfo.cnicLast6}
                    onChange={(e) =>
                      setPayerInfo({ ...payerInfo, cnicLast6: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex flex-column gap-1">
                  <label id="refno" className="fs14">
                    Refrence No.
                  </label>
                  <Input
                    className="w-100 p-2 rounded-3"
                    name="refno"
                    placeholder="Enter Refrence No"
                    value={payerInfo.refNo}
                    onChange={(e) =>
                      setPayerInfo({ ...payerInfo, refNo: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="col-12">
                <button
                  className="btn  w-100 p-2"
                  style={{ background: "#FBAD1A" }}
                  onClick={() => onPayClick()}
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
